import { useToken } from "@gluestack-style/react";
import { Box } from "components/ui";
import React, { useEffect } from "react";
import { Animated, StyleSheet, View, Easing } from "react-native";
import { apiRunningState } from "store/baseApi";
const LinearActivityIndicator = () => {
	const resolvedSecondary = useToken("colors", "secondarydark");
	const primaryColor = useToken("colors", "primary");

	const firstBar = React.useRef(new Animated.Value(0)).current;
	const secondBar = React.useRef(new Animated.Value(0)).current;

	useEffect(() => {
		Animated.loop(
			Animated.sequence([
				Animated.timing(firstBar, {
					toValue: 1,
					duration: 1260, // 60% of 2100ms
					easing: Easing.bezier(0.65, 0.815, 0.735, 0.395),
					useNativeDriver: true,
				}),
				Animated.delay(840), // 40% of 2100ms - hold time
			]),
		).start();

		const secondBarAnimation = Animated.loop(
			Animated.sequence([
				Animated.timing(secondBar, {
					toValue: 1,
					duration: 1260, // 60% of 2100ms
					easing: Easing.bezier(0.165, 0.84, 0.44, 1),
					useNativeDriver: true,
				}),
				Animated.delay(840), // 40% of 2100ms - hold time
			]),
		);

		const timer = setTimeout(() => {
			secondBarAnimation.start();
		}, 1150);

		return () => {
			clearTimeout(timer);
		};
	}, []);

	const firstBarLeft = firstBar.interpolate({
		inputRange: [0, 1],
		outputRange: ["-35%", "100%"],
	});

	const firstBarRight = firstBar.interpolate({
		inputRange: [0, 1],
		outputRange: ["100%", "-90%"],
	});

	const secondBarLeft = secondBar.interpolate({
		inputRange: [0, 1],
		outputRange: ["-200%", "107%"],
	});

	const secondBarRight = secondBar.interpolate({
		inputRange: [0, 1],
		outputRange: ["100%", "-8%"],
	});
	const [isApiRunning] = apiRunningState.use();
	if (!isApiRunning) {
		return null;
	}
	return (
		<Box position="absolute" right={0} left={0} top={0} zIndex={1000} height={4} width="100%" backgroundColor={resolvedSecondary} overflow="hidden">
			<Animated.View
				style={[
					styles.bar,
					{
						backgroundColor: primaryColor,
						left: firstBarLeft,
						right: firstBarRight,
					},
				]}
			/>

			<Animated.View
				style={[
					styles.bar,
					{
						backgroundColor: primaryColor,
						left: secondBarLeft,
						right: secondBarRight,
					},
				]}
			/>
		</Box>
	);
};

const styles = StyleSheet.create({
	bar: {
		position: "absolute",
		top: 0,
		bottom: 0,
	},
});

export default LinearActivityIndicator;
